import { ContainerPadding, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { FIELD_NAME } from '../../../../constants/form-constants';
import { useApp } from '../../../../contexts/app-context';
import { vehicleEntity } from '../../../../entities/vehicle-entity';
import { formService } from '../../../../form-service';
import {
	isLeadVentaCitaForm,
	isLeadVentaPresupuestoForm,
	isLeadVentaStockForm,
	isLeadVentaTestDriveForm,
	isLeadVentaVehiculoOcasionForm,
} from '../../../../helpers/form-helpers';
import { getCarlines } from '../../../../service/api/get-carlines';
import { isMarketingCodeFetching } from '../../../../service/api/get-marketing-code';
import { getExternalContentSalesgroups } from '../../../../service/api/get-salesgroups';
import { Carline, SalesgroupWithCarline } from '../../../../types/vehicle-types';
import { InputsGroup } from '../../../screen/inputs-group';
import { LoadingScreen } from '../../../screen/loading';
import { Section } from '../../../screen/section';
import { VehicleSelect } from '../vehicle-select';
import { SelectorView } from './selector-view/selector-view';
import { VehicleSingleView } from './vehicle-single-view/vehicle-single-view';

interface Props {
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
}

export const VehicleSection = (props: Props) => {
	const { paddingTop, paddingBottom } = props;
	const { setAppError, setAppErrorLog } = useApp();
	const [carlines, setCarlines] = useState<Carline[]>();
	const [salesgroups, setSalesgroups] = useState<SalesgroupWithCarline[]>();
	const [loading, setLoading] = useState(true);
	const [preconfiguration, setPreconfiguration] = useState(vehicleEntity.preconfiguration);
	const [preTitle, setPreTitle] = useState('Quieres más información sobre un');
	const [postTitle, setPostTitle] = useState('');

	useEffect(() => {
		if (isLeadVentaPresupuestoForm()) setPreTitle('Quieres un presupuesto para un');
		if (isLeadVentaTestDriveForm()) setPreTitle('Quieres probar un');
		if (isLeadVentaCitaForm()) {
			setPreTitle('Quieres venir a ver un');
			setPostTitle('en tu instalación más cercana');
		}
		if (isLeadVentaStockForm()) {
			setPreTitle('Quieres un');
			setPostTitle('nuevo en stock');
		}
		if (isLeadVentaVehiculoOcasionForm()) {
			setPreTitle('Quieres un');
			setPostTitle('de ocasión');
		}
	});

	useEffect(() => {
		const unsubscribe = formService.subscribeToField(FIELD_NAME.VEHICLE_PRECONFIGURATION, {
			onChange: () => setPreconfiguration(vehicleEntity.preconfiguration),
		});

		if (!vehicleEntity.carline || !vehicleEntity.salesgroup) {
			// Priorizamos la carga de Salesgroups
			getExternalContentSalesgroups().then((salesgroups) => {
				setLoading(false);
				if (!salesgroups) {
					setLoading(true);
					getCarlines().then((carlines) => {
						setLoading(false);
						if (!carlines) {
							setAppError(true);
							setAppErrorLog('No se ha obtenido ningún carline');
						}
						setCarlines(carlines || undefined);
						formService.setFieldValue(FIELD_NAME.CARLINE, carlines?.length == 1 ? carlines[0] : undefined);
					});
				}
				setSalesgroups(salesgroups || undefined);
				formService.setFieldValue(FIELD_NAME.SALESGROUP, salesgroups?.length == 1 ? salesgroups[0] : undefined);
			});
		} else {
			setPreconfiguration(vehicleEntity.preconfiguration);
			if (vehicleEntity.carline && !vehicleEntity.preconfiguration) {
				setCarlines([vehicleEntity.carline]);
			}
			setLoading(false);
		}

		return unsubscribe;
	}, []);

	const isSingleView = Boolean(
		preconfiguration ||
		carlines?.length == 1 ||
		salesgroups?.length == 1 ||
		(vehicleEntity.carline && !salesgroups) ||
		vehicleEntity.salesgroup,
	);

	return loading || isMarketingCodeFetching() ? (
		<LoadingScreen />
	) : (
		<Section paddingTop={paddingTop} paddingBottom={paddingBottom}>
			<Text bold appearance={TokenTextAppearance.headline300}>
				¿{preTitle} Volkswagen
				{postTitle.length != 0 ? ' ' + postTitle : ''}?
			</Text>
			{isLeadVentaVehiculoOcasionForm() ? (
				<InputsGroup>
					<VehicleSelect carlines={carlines} salesgroups={salesgroups} required />
				</InputsGroup>
			) : isSingleView ? (
				<VehicleSingleView />
			) : (
				<SelectorView carlines={carlines} salesgroups={salesgroups} required />
			)}
		</Section>
	);
};
